import { Box, Grid } from "@mui/material";
import Image from "next/image";
import PowerOfFiveBanner from "../../public/assets/images/tv/PowerOfFiveBanner01.webp";
import Seo from "../../components/Seo";

function gromoTV(params) {
  const tvContainerStyles = {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.7)", // Simulate a shadow
    // backgroundColor: '#222',
  };

  const tvImageStyles = {
    width: "100%",
    height: "auto",
    display: "block",
  };

  return (
    <>
      <Seo
        title="GroMo TV"
        description="Watch GroMo highlights and featured content."
        openGraph={{
          title: "GroMo TV",
          description: "Watch GroMo highlights and featured content.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        twitter={{
          title: "GroMo TV",
          description: "Watch GroMo highlights and featured content.",
          url: "https://gromo.in/tv",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
      />
      <Grid
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "black",
        }}
      >
        <Box style={tvContainerStyles}>
          <Image
            src={PowerOfFiveBanner}
            alt={"PowerOfFiveBanner"}
            style={tvImageStyles}
            loading="lazy"
          />
        </Box>
      </Grid>
    </>
  );
}
export default gromoTV;
